export default function onExpand(from = '', to: string) {
  return from === to;
}
